((VideoModal, $) => {
  'use strict';

  const $dom = {};

  const cacheDom = () => {
    $dom.closeModalBtn = $('.js-video-modal-close');
    $dom.videoModalBtn = $('.js-video-modal-btn');
    $dom.videoModal = $('.js-video-modal');
    $dom.overlay = $('[data-overlay]');
  }

  VideoModal.openVideoModal = $el => {
    if ($('.js-video-modal-iframe').length > 0) {
      let videoSrc = $el.attr('data-video-src');
      let $iframe = $dom.videoModal.find('.js-video-modal-iframe');
      $iframe.attr('src', videoSrc);
      $dom.videoModal.addClass('active');
    } else {
      $('<iframe>', {
        src: $el.attr('data-video-src'),
        id:  'myFrame',
        class: 'video-modal__iframe js-video-modal-iframe',
        frameborder: 0,
        allowfullscreen: true,
        allow: 'autoplay; encrypted-media'
      }).appendTo('.video-modal__inner');
      $dom.videoModal.addClass('active');
    }
    
    Overlay.show();
    Scroll.lock();
  }

  VideoModal.closeVideoModal = () => {
    let $iframe = $dom.videoModal.find('.js-video-modal-iframe');
    Overlay.hide();
    Scroll.unlock();
    $iframe.attr('src', '');
    $iframe.remove();
    $dom.videoModal.removeClass('active');
  }

  const autoplay = () => {
    if (location.hash == '#video') {
      $('.pdp-details-video-link.js-video-modal-btn').trigger('click');
    }
  }

  const bindUIActions = () => {
    $dom.videoModalBtn.on('click', event => {
      VideoModal.openVideoModal($(event.currentTarget));
    })

    $dom.closeModalBtn.on('click', function(e) {
      VideoModal.closeVideoModal();
    })

    $dom.overlay.on('click', function() {
      VideoModal.closeVideoModal();
    })

    $(document).ready(function() {
      autoplay();
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  VideoModal.init = init;

})(window.VideoModal = window.VideoModal || {}, jQuery);
